import {environment} from '../../../../../environments/environment';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { PostcodeLookupServiceInterface } from '../postcode-lookup-service-interface';
import { SessionService } from '../../session.service';

@Injectable()
export class LoqateProvider implements PostcodeLookupServiceInterface {
    private base_url: string = 'https://services.postcodeanywhere.co.uk/';
    private api_url: string = environment.api_url;

    constructor(private http_client: HttpClient, private session_service: SessionService) {}

    searchAddress(search_term: string): Observable<any> {
        const headers = new HttpHeaders({
            Domain: this.session_service.domain,
        });

        const url = new URL(`${this.api_url}core/postcode-lookup/get-suggested-addresses/loqate/${search_term}`);
        const response = this.http_client.get(url.toString(), {headers: headers});

        return response;
    }

    getAddressById(id: string): Observable<any> {
        const headers = new HttpHeaders({
            Domain: this.session_service.domain,
        });

        const url = new URL(`${this.api_url}core/postcode-lookup/get-address/loqate/${id}`);
        const response = this.http_client.get(url.toString(), {headers: headers});

        return response;
    }

    formatSuggestedAddresses(response): string[] {
        return response.Items.map((item) => {
            return {
                id: item.Id,
                text: item.Text,
            };
        });
    }

    formatAddress(response): any {
        const address = response.Items[0];
        return {
            line1: address.Line1,
            line2: address.Line2,
            line3: address.Line3,
            city: address.City,
            county: address.Province,
            postcode: address.PostalCode,
            company: address.Company,
            subBuilding: address.SubBuilding ?? null,
            buildingNumber: address.BuildingNumber ?? null,
            buildingName: address.BuildingName ?? null,
            street: address.Street ?? null,
        };
    }
}
